import React, { useState } from "react";
import "../styles/App.css";

interface IntroVideoProps {
  onFinish: () => void;
}

const IntroVideo: React.FC<IntroVideoProps> = ({ onFinish }) => {
  const [hover, setHover] = useState(false);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "linear-gradient(135deg, #e0eaff 0%, #c2d8ff 100%)",
        zIndex: 2000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "inherit",
      }}
    >
      <div
        style={{
          background: "white",
          borderRadius: 28,
          boxShadow:
            "0 8px 32px rgba(36,62,99,0.18), 0 2px 8px rgba(36,62,99,0.10)",
          padding: "40px 32px 32px 32px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "90vw", // Responsive width
          maxWidth: 720,
        }}
      >
        <div
          style={{
            position: "relative",
            width: "100%",
            paddingBottom: "56.25%" /* 16:9 aspect ratio */,
            height: 0,
            marginBottom: 32,
            maxWidth: 640,
            borderRadius: 20,
            overflow: "hidden",
            background: "#f3f7fa",
            boxShadow: "0 2px 12px rgba(36,62,99,0.10)",
          }}
        >
          <iframe
            src="https://www.youtube.com/embed/mey9ApYzuoY"
            title="Intro Video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              border: 0,
            }}
          />
        </div>
        <button
          className="main-btn"
          onClick={onFinish}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          style={{
            background: hover ? "#a7d8ff" : "#7eaaff",
            color: "#24406b",
            border: "none",
            borderRadius: 14,
            padding: "14px 40px",
            fontSize: "1.15rem",
            fontWeight: 600,
            fontFamily: '"Quicksand", "Inter", sans-serif',
            boxShadow: hover
              ? "0 6px 20px rgba(36,62,99,0.12)"
              : "0 2px 8px rgba(36,62,99,0.08)",
            cursor: "pointer",
            outline: "none",
            transform: hover ? "scale(1.04)" : "scale(1)",
            transition:
              "background 0.25s cubic-bezier(.4,0,.2,1), box-shadow 0.25s cubic-bezier(.4,0,.2,1), transform 0.25s cubic-bezier(.4,0,.2,1)",
          }}
        >
          I have finished the video
        </button>
      </div>
    </div>
  );
};

export default IntroVideo;